// A'gong Export — The Problem — scroll animations
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('[data-agong-export-problem]')) return;

  if (!window.IntersectionObserver) {
    document.querySelectorAll('[data-agong-ep-anim]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('[data-agong-ep-anim]').forEach(function (el) {
    observer.observe(el);
  });
});
